import client from "libs/client";

export function useProviderOperationsSearch(query: string) {
	return client.getProviderOperationsSearch.useQuery({ q: query });
}
